import * as React from 'react';
import { observable } from 'mobx';
import { WritingSectionPageState } from './states/WritingSectionPageState';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { ExamWritingSectionView } from '../../components/organisms/exam_sections/ExamWritingSectionView';
import { ExamWritingSectionScoreView } from '../../components/organisms/exam_sections/ExamWritingSectionScoreView';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../routes';
import { observer } from 'mobx-react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { authenticated } from '../../components/hocs/authenticated';

type Props = {
    match: {
        params: {
            sectionId: string;
        };
    };
};

@authenticated
@withNavigation(NavigationSpecs.home('none'), NavigationSpecs.home('white', false))
@observer
export class WritingSectionPage extends React.Component<Props> {
    @observable pageState = new WritingSectionPageState();
    componentDidMount(): void {
        const sectionId = Number(this.props.match.params.sectionId);
        this.pageState.init(sectionId);
    }

    render() {
        const {
            section,
            answerState,
            showScore,
            submitAndScore,
            submitState,
            writingSectionSubmissionCode,
        } = this.pageState;

        if (section.loading && section.isEmpty()) {
            return <LoaderRow />;
        }
        if (section.isNotFound()) {
            return <NotFoundPage entityType="課題" />;
        }
        const sec = section.get();
        return (
            <div>
                {!showScore && (
                    <ExamWritingSectionView
                        answerState={answerState}
                        onSubmit={submitAndScore}
                        submitting={submitState.submitting}
                        title={sec.course.title}
                    />
                )}
                {showScore && (
                    <ExamWritingSectionScoreView
                        answerState={answerState}
                        onExit={() => GlobalStatesV3.routing.push(V3Routes.course(sec.course.id))}
                        title={sec.course.title}
                        code={writingSectionSubmissionCode}
                    />
                )}
            </div>
        );
    }
}
